// extracted by mini-css-extract-plugin
export default {"notification":"style_notification__JOV0a","modal":"style_modal__GpaCD"};